import { styled } from '@mui/material/styles';
import CustomEstimateIcon from '@/assets/custom-estimate.svg?react';
import LetsGetMovingIcon from '@/assets/lets-get-moving.svg?react';

export const LetsGetMovingGraphic = styled(LetsGetMovingIcon)({
  background: 'transparent !important',
  width: '100%',
  maxWidth: 280,
  height: 'auto',
});

export const EstimateGraphic = styled(CustomEstimateIcon)({
  width: 120,
  height: 120,
  margin: '0 auto',
  display: 'block',
});
